export const APP_DEFAULT_SITE_NAME = 'WorkOrder HQ™';

export const PRODUCT_NAME = 'WorkOrder HQ™';
export const PRODUCT_NAME_SHORT = 'WorkOrder HQ™';
export const PRODUCT_DESCRIPTION = 'The complete work order management solution for field service businesses.';
export const PRODUCT_EMAIL_DOMAIN = 'workorderhq.com';
export const PRODUCT_SUPPORT_EMAIL = 'support@workorderhq.com';
export const PRODUCT_SALES_EMAIL = 'sales@workorderhq.com';
export const PRODUCT_HELP_EMAIL = 'help@workorderhq.com';

